import { Component, OnInit, EventEmitter, Output, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-numero-filter',
  templateUrl: './numero-filter.component.html',
  styleUrls: ['./numero-filter.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NumeroFilterComponent),
      multi: true
    }
  ]
})
export class NumeroFilterComponent implements OnInit {

  numero: number;
  @Output() confirmNotify: EventEmitter<any> = new EventEmitter<any>();
  @Output() quitNotify: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  confirm() {
    this.confirmNotify.emit({ q: { field: 'numero', value: this.numero }, t: { k: 'numero', v: this.numero, l: 'numero' } });
  }

  enter(e) {
    if (e) e.preventDefault();

    if (this.numero) {
      this.confirm()
    }
  }

  quit() {
    this.quitNotify.emit();
  }

  ngOnInit() {
  }

  private propagateChange = (_: any) => { };

  public writeValue(s: number) {
    this.numero = s;
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() { }
}



// WEBPACK FOOTER //
// ./src/app/helpers/filters/numero-filter/numero-filter.component.ts